import { css } from 'lit';

export const inboxViewStyles = css`

  view-content {
    padding-top: 6rem;
    max-width: none;
  }

  header-bar {
    --header-icon-color: var(--gray-4);
    --header-icon-opacity: 0.5;
    --header-icon-bottom-position: -3.5rem;
  }

  header-bar button-bar {
    align-items: center;
  }
  header-bar button-bar .timestamp {
    font-size: 0.9rem;
    font-style: italic;
    color: var(--gray-6);
    font-weight: 300;
  }

  sl-avatar {
    --size: 1.5rem;
  }

  table.q1 {
    margin: var(--view-item-spacing) 0;
    --table-td-bg-focus-color: white;
  }
  table.q1 td {
    cursor: pointer;
  }
  table.q1 tr {
    transition: all 0.2s ease-in-out;
  }
  table.q1 tbody tr:hover,
  table.q1 tbody tr:focus {
    box-shadow: var(--sl-shadow-small);
    position: relative;
    z-index: 10;
  }

  table.q1 thead tr {
    border-top-left-radius: var(--table-border-radius);
    border-top-right-radius: var(--table-border-radius);
  }
  table.q1 tbody tr:last-child {
    border-bottom-left-radius: var(--table-border-radius);
    border-bottom-right-radius: var(--table-border-radius);
  }

`;
